export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-16 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
                手机阅读
              </h2>
              <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
                随时随地畅享韩国漫画！支持各大韩国漫画网站的移动端阅读入口，适配手机屏幕的流畅阅读体验，让精彩内容不再受限于设备。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
                >
                  <i className="ri-smartphone-line"></i>
                  移动端入口
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-background-50/40 text-background-50 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-50/10 transition-colors"
                >
                  <i className="ri-qr-code-line"></i>
                  扫码体验
                </a>
              </div>
            </div>
            <div className="flex-1 p-8 flex justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-background-50/10 rounded-3xl blur-2xl"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20Korean%20webtoon%20manhwa%20style%20interface%20with%20warm%20coral%20and%20cream%20color%20scheme%2C%20clean%20UI%20design%2C%20elegant%20minimalist%20presentation%2C%20floating%20phone%20on%20soft%20gradient%20background%2C%20digital%20product%20photography%2C%20no%20text%2C%20professional%20render&width=600&height=800&seq=app-mobile-kr-comics&orientation=portrait"
                  alt="韩国漫画手机阅读"
                  className="w-56 md:w-64 h-auto relative z-10"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}